<!-- cart.component.html -->
<h2>Carrito</h2>
<table>
  <tr *ngFor="let item of cartItems">
    <td>{{ item.name }}</td>
    <td>{{ item.price | currency }}</td>
    <td>x {{ item.qty }}</td>
    <td>{{ item.price * item.qty | currency }}</td>
  </tr>
</table>
<p>Total: {{ total | currency }}</p>
<button>Proceder a Checkout</button>
